<!-- 게시판글 표현 -->
<template>
  <swiper
    :slides-per-view="1"
    :space-between="0"
     :loop="true"
    navigation
    :pagination="{ clickable: true }"  
    :autoplay="{ delay: 10000,disableOnInteraction:false}" 
    @swiper="onSwiper"
    @slideChange="onSlideChange"
  >
    <template v-for="(post, index) in posts" :key="index" >
        <swiper-slide>
            <div class="slide_image" :style="{backgroundImage:'url('+ getImage(post.content)+')'}" 
                @click="updateCount(post.id, post.document.menu, post.document.name)"
                
                >
                <div class="contArea">
                    <post-title :document="post.document.name" :list="post" :menu="post.document.menu" mode="main"/>  
                       
                </div>    
            </div>    
        </swiper-slide>
    </template> 
    
  </swiper>
</template>
<script>
  // import Swiper core and required modules
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper';

  // Import Swiper Vue.js components
import { Swiper, SwiperSlide } from 'swiper/vue';
import { removeAllTag } from '@/utils/removetag';
import PostTitle from '@/components/posts/PostTitle.vue';
import { postLink } from '@/utils/menu';
  // install Swiper modules
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay]);

  // Import Swiper styles
export default {
    props:[
        'posts'
    ],
    data(){
        return{
            mainview:null
        }
    },     
    components: {
        PostTitle,
        Swiper,
        SwiperSlide,
    },
    methods: {
        // onSwiper(swiper) {
        //     console.log(swiper);
        // },
        // onSlideChange() {
        //     console.log('slide change');        
        // },
       getImage(cont)
        {
            const step1 = cont.split('<img src="')           
            if ( step1.length === 1)
            {
                //대체 이미지 
                return '';
            } 
            const step2 = step1[1].split('">')
            //웹에서 긁어온 이미지때문에 한번더 파싱
            const step3= step2[0].split('" ')
            return step3[0];         
        },
        getCont(cont)
        {      
            const removetag = removeAllTag(cont);           
            return removetag.substr(0, 130) + (removetag.length >130?'...':'') ;
        },
        updateCount(post_id,menu_title,document)
        {
            const menu = this.$store.getters['menu/getMenu'].find((menus)=>menus.title === menu_title).name;
            postLink(post_id,menu,document,this.$store);   
            this.$router.push({
                path: "/main/community/" + menu +"/"+document+"/view/"+post_id                
            }); 
        },
    },
};
</script>
<style lang="scss" >
@import '@/assets/swiper/swiper.scss';
@import '@/assets/swiper/components/navigation/navigation.scss';
@import '@/assets/swiper/components/pagination/pagination.scss';
.swiper-slide{
    height:400px;
    width:700px;
    .slide_image{
        width:100%;
        height:100%;
        background-size: cover;
        display:flex;
        flex-direction:column;
        justify-content: flex-end;
        cursor: pointer;
         .contArea{
            background:#000;
            opacity:.7;
            font-size:20px;  
            font-weight:bold;
            padding:10px;    
            height:80px;
            .title{
                a{color:#fff;font-weight:bold}
            }
        }
    }
   

}

</style>